import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { AnyAction, Reducer } from '@reduxjs/toolkit';
import { RootState } from '../../@types/RootState';
import {
  ADD_SEGMENT_VALUE,
  RESET_FILTERS_VALUE,
  RESET_FILTERS_VALUE_BY_KEY,
  SET_FILTERS_VALUE,
  SET_FILTERS_VALUE_BY_KEY,
  SET_PRICE_STATUS,
  UPDATE_FILTERS_VALUE_BY_KEY,
} from './filters/filtersValues';
import {
  CLEAN_MORE_FILTERS_RENDER_BY_KEY,
  DELETE_MORE_FILTERS_PILL_BY_VALUE,
  RESET_MORE_FILTERS,
  SET_MORE_FILTERS_VALUE_RENDER_BY_KEY,
} from './filters/moreFilters';
import {
  CHANGE_QUICK_FILTER_VALUE,
  RESET_QUICK_ACTION_FILTER,
  setChangedCostsFilter,
  setChangedCostsIsActive,
  setCompetitivenessFilter,
  setMarginFilter,
  setMinDateCompetitorPriceSource,
  setPriceVariationFilter,
  toggleChangedCostsIsActive,
  togglePriceCPI,
  toggleQuickActionFilter,
  toggleQuickFilter,
  toggleQuickFilterOff,
  TOGGLE_QUICK_FILTER_ON,
} from './quickActionsFilter';

export type GerenciadorPaginationState = {
  activePage: number;
  displayLength: number;
};

const initialState: GerenciadorPaginationState = {
  activePage: 0,
  displayLength: 25,
};

const slice = createSlice({
  name: 'gerenciadorPrecos/pagination',
  initialState,
  reducers: {
    SET_ACTIVE_PAGE(state, action: PayloadAction<number>) {
      state.activePage = action.payload;
    },
    SET_DISPLAY_LENGTH(state, action: PayloadAction<number>) {
      state.displayLength = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addMatcher(
      action =>
        [
          SET_FILTERS_VALUE.type,
          SET_FILTERS_VALUE_BY_KEY.type,
          UPDATE_FILTERS_VALUE_BY_KEY.type,
          RESET_FILTERS_VALUE.type,
          RESET_FILTERS_VALUE_BY_KEY.type,
          ADD_SEGMENT_VALUE.type,
          SET_PRICE_STATUS.type,
          RESET_MORE_FILTERS.type,
          SET_MORE_FILTERS_VALUE_RENDER_BY_KEY.type,
          CLEAN_MORE_FILTERS_RENDER_BY_KEY.type,
          DELETE_MORE_FILTERS_PILL_BY_VALUE.type,
          TOGGLE_QUICK_FILTER_ON.type,
          toggleQuickFilterOff.type,
          toggleQuickFilter.type,
          CHANGE_QUICK_FILTER_VALUE.type,
          RESET_QUICK_ACTION_FILTER.type,
          toggleQuickActionFilter.type,
          togglePriceCPI.type,
          setMinDateCompetitorPriceSource.type,
          setMarginFilter.type,
          setPriceVariationFilter.type,
          setCompetitivenessFilter.type,
          setChangedCostsFilter.type,
          toggleChangedCostsIsActive.type,
          setChangedCostsIsActive.type,
        ].includes(action.type),
      state => {
        state.activePage = initialState.activePage;
      },
    );
  },
});

const selectorPagination = (state: RootState): GerenciadorPaginationState => {
  return state.gerenciadorPrecosReducer.pagination;
};

const { SET_ACTIVE_PAGE, SET_DISPLAY_LENGTH } = slice.actions;
const paginationReducer: Reducer<GerenciadorPaginationState, AnyAction> = slice.reducer;

export { selectorPagination, SET_ACTIVE_PAGE, SET_DISPLAY_LENGTH };

export default paginationReducer;
